module.exports = __webpack_public_path__ + "static/media/Payroll-1.a2b35fc6.svg";